import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule, SelectModule, InputModule } from '@sag-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { ResetCodReview } from '../../../state/cod-review.action';
import { Router } from '@angular/router';

@Component({
    selector: 'app-review-success-step',
    templateUrl: './review-success.component.html',
    imports: [CommonModule, SelectModule, FormsModule, ReactiveFormsModule, InputModule, ButtonModule],
    standalone: true
})
export class CodReviewSuccessComponent {
    constructor(private router: Router, private store: Store) {}

    public backToDashboard(): void {
        this.store.dispatch(new ResetCodReview());
        this.router.navigate(['/']);
    }
}
